import React from 'react';
import Icon from '../../../components/AppIcon';

const ServiceCard = ({ service, index }) => {
  return (
    <div className="group bg-card border border-border rounded-lg p-6 md:p-8 hover:shadow-xl transition-all duration-300 hover:border-primary/50 h-full flex flex-col">
      <div className="flex items-start justify-between mb-4 md:mb-6">
        <div className={`w-12 h-12 md:w-16 md:h-16 rounded-lg flex items-center justify-center ${service?.bgColor} group-hover:scale-110 transition-transform duration-300`}>
          <Icon name={service?.icon} size={24} color={service?.iconColor} className="md:w-8 md:h-8" />
        </div>
        <span className="text-xs md:text-sm font-medium font-body text-muted-foreground bg-muted px-3 py-1 rounded-full">
          {service?.category}
        </span>
      </div>
      <h3 className="text-xl md:text-2xl font-bold font-headline text-foreground mb-3 md:mb-4 group-hover:text-primary transition-colors duration-200">
        {service?.title}
      </h3>
      <p className="text-sm md:text-base text-muted-foreground font-body mb-4 md:mb-6 leading-relaxed flex-grow">
        {service?.description}
      </p>
      <div className="space-y-3 md:space-y-4 mb-4 md:mb-6">
        <div className="flex items-start space-x-3">
          <Icon name="CheckCircle2" size={18} color="var(--color-success)" className="mt-1 flex-shrink-0" />
          <span className="text-xs md:text-sm text-foreground font-body">{service?.feature1}</span>
        </div>
        <div className="flex items-start space-x-3">
          <Icon name="CheckCircle2" size={18} color="var(--color-success)" className="mt-1 flex-shrink-0" />
          <span className="text-xs md:text-sm text-foreground font-body">{service?.feature2}</span>
        </div>
        <div className="flex items-start space-x-3">
          <Icon name="CheckCircle2" size={18} color="var(--color-success)" className="mt-1 flex-shrink-0" />
          <span className="text-xs md:text-sm text-foreground font-body">{service?.feature3}</span>
        </div>
      </div>
      <div className="pt-4 md:pt-6 border-t border-border">
        <div className="flex items-center justify-between">
          {/* <span className="text-xs md:text-sm text-muted-foreground font-body">
            Starting from <span className="font-semibold text-foreground">{service?.pricing}</span>
          </span> */}
          <a
            href="#contact-form"
            className="inline-flex items-center space-x-2 text-primary hover:text-primary/80 font-medium font-cta text-sm transition-colors duration-200"
          >
            <span>Learn More</span>
            <Icon name="ArrowRight" size={16} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;